const base = {
  default: {
    padding: '14px',
    height: '70px',
    ['@media (max-width: 1000px)']: {
      padding: 0
    }
  }
};

const children = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type ChildrenVariantsType = 'default';
export const childrenVariants = Object.keys(base) as ChildrenVariantsType[];

export default children;
